import React, { useMemo } from 'react';
import { StyledDashboard, StyledMain } from './styled';
import { Redirect, Route, Switch } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import { useSelector } from 'react-redux';
import NotFound from './pages/NotFound';
import { paths, getRoutesDashboard } from '../../routes';
import RouteTitle from '../../routes/RouteTitle';
import Socket from './components/Socket';

const Dashboard = () => {
    const role = useSelector(state => state.auth.user?.user?.role?.type);

    const routesDashboard = useMemo(() => getRoutesDashboard(role), [role]);

    return (
        <StyledDashboard>
            <Socket />
            <Sidebar />
            <StyledMain>
                <Switch>
                    <Redirect exact from='/' to={paths.jobs} />
                    {
                        routesDashboard && Object.values(routesDashboard).map(route => (
                            <RouteTitle title={route.name} exact={route.exact} path={route.path} component={route.component} key={route.path} />
                        ))
                    }
                    <Redirect from={paths.jobs} to={paths.jobsActive} />
                    <Route path="*">
                        <NotFound />
                    </Route>
                </Switch>
            </StyledMain>
        </StyledDashboard>
    )
};

export default Dashboard;
